import { LtButton, LtButtonGroup } from '@lit-element/components/button'
import { LtIcon } from '@lit-element/components/icon'
import {
  LtCheckbox,
  LtCheckboxButton,
  LtCheckboxGroup,
} from '@lit-element/components/checkbox'
import { LtInput } from '@lit-element/components/input'
import { LtSwitch } from '@lit-element/components/switch'
import { LtTimePicker } from '@lit-element/components/time-picker'
import { LtColorPicker } from '@lit-element/components/color-picker'
import { LtDatePicker } from '@lit-element/components/date-picker'
import { LtTabPane, LtTabs } from '@lit-element/components/tabs'
import {
  LtOption,
  LtOptionGroup,
  LtSelect,
} from '@lit-element/components/select'
import { LtTooltip } from '@lit-element/components/tooltip'
import {
  LtRadio,
  LtRadioButton,
  LtRadioGroup,
} from '@lit-element/components/radio'
import { LtCascader } from '@lit-element/components/cascader'
import { LtCascaderPanel } from '@lit-element/components/cascader-panel'
import { LtTag } from '@lit-element/components/tag'
import { LtCheckTag } from '@lit-element/components/check-tag'
import { LtTree } from '@lit-element/components/tree'
import { LtAutocomplete } from '@lit-element/components/autocomplete'
import { LtCarousel, LtCarouselItem } from '@lit-element/components/carousel'
import { LtBacktop } from '@lit-element/components/backtop'
import { LtTimeSelect } from '@lit-element/components/time-select'
import { LtForm, LtFormItem } from '@lit-element/components/form'
import {
  LtDropdown,
  LtDropdownItem,
  LtDropdownMenu,
} from '@lit-element/components/dropdown'
import { LtAlert } from '@lit-element/components/alert'
import { LtPopper } from '@lit-element/components/popper'
import { LtSelectV2 } from '@lit-element/components/select-v2'
import { LtMention } from '@lit-element/components/mention'
import { LtUpload } from '@lit-element/components/upload'
import {
  LtAside,
  LtContainer,
  LtFooter,
  LtHeader,
  LtMain,
} from '@lit-element/components/container'
import { LtLink } from '@lit-element/components/link'
import { LtSlider } from '@lit-element/components/slider'
import { LtSpace } from '@lit-element/components/space'
import { LtText } from '@lit-element/components/text'
import { LtCol } from '@lit-element/components/col'
import {
  LtDescriptions,
  LtDescriptionsItem,
} from '@lit-element/components/descriptions'
import { LtAvatar } from '@lit-element/components/avatar'
import { LtStatistic } from '@lit-element/components/statistic'
import { ltCountdown } from '@lit-element/components/countdown'
import { LtCalendar } from '@lit-element/components/calendar'
import { LtEmpty } from '@lit-element/components/empty'
import { LtResult } from '@lit-element/components/result'
import { LtPagination } from '@lit-element/components/pagination'
import { LtAutoResizer, LtTableV2 } from '@lit-element/components/table-v2'
import { LtAffix } from '@lit-element/components/affix'
import { LtImage } from '@lit-element/components/image'
import { LtImageViewer } from '@lit-element/components/image-viewer'
import { LtTimeline, LtTimelineItem } from '@lit-element/components/timeline'
import {
  LtBreadcrumb,
  LtBreadcrumbItem,
} from '@lit-element/components/breadcrumb'
import { LtPageHeader } from '@lit-element/components/page-header'
import { LtTour, LtTourStep } from '@lit-element/components/tour'
import { LtSkeleton, LtSkeletonItem } from '@lit-element/components/skeleton'
import { LtDivider } from '@lit-element/components/divider'
import { LtTreeV2 } from '@lit-element/components/tree-v2'
import { LtAnchor, LtAnchorLink } from '@lit-element/components/anchor'
import { LtScrollbar } from '@lit-element/components/scrollbar'
import { LtConfigProvider } from '@lit-element/components/config-provider'
import { LtSegmented } from '@lit-element/components/segmented'
import { LtPopoverTip } from '@lit-element/components/tooltip-v2'
import { LtDialog } from '@lit-element/components/dialog'
import { LtBadge } from '@lit-element/components/badge'
import { LtCard } from '@lit-element/components/card'
import { LtCollapse, LtCollapseItem } from '@lit-element/components/collapse'
import { LtCollapseTransition } from '@lit-element/components/collapse-transition'
import { LtDrawer } from '@lit-element/components/drawer'
import { LtInputNumber } from '@lit-element/components/input-number'
import {
  LtMenu,
  LtMenuItem,
  LtMenuItemGroup,
  LtSubMenu,
} from '@lit-element/components/menu'
import { LtPopconfirm } from '@lit-element/components/popconfirm'
import { LtPopover } from '@lit-element/components/popover'
import { LtProgress } from '@lit-element/components/progress'
import { LtRate } from '@lit-element/components/rate'
import { LtRow } from '@lit-element/components/row'
import { LtStep, LtSteps } from '@lit-element/components/steps'
import { LtTable, LtTableColumn } from '@lit-element/components/table'
import { LtTransfer } from '@lit-element/components/transfer'
import { LtTreeSelect } from '@lit-element/components/tree-select'
import { LtWatermark } from '@lit-element/components/watermark'
import { LtQrcode } from '@lit-element/components/qrcode'
import { LtWheel } from '@lit-element/components/wheel'
import { LtHighlight } from '@lit-element/components/highlight'
import { LtEllipsis } from '@lit-element/components/ellipsis'
import { LtTimeAgo } from '@lit-element/components/time-ago'
import { LtSplit } from '@lit-element/components/split'
import { LtViewer } from '@lit-element/components/viewer'
import { LtCaptcha, LtCaptchaSlider } from '@lit-element/components/captcha'
import { LtFullScreen } from '@lit-element/components/fullScreen'
import { LtMasker } from '@lit-element/components/masker'
import { LtRenderer } from '@lit-element/components/renderer'
import { LtEditorMd, LtRenderMd } from '@lit-element/components/editor-md'
import { LtOverflow } from '@lit-element/components/overflow'
import { LtCodeEditor } from '@lit-element/components/codeEditor'
import { LtComment } from '@lit-element/components/comment'
import { LtVerificationCode } from '@lit-element/components/verification-code'
import { LtResizeObserver } from '@lit-element/components/resize-observer'
import { LtGitGraph } from '@lit-element/components/git-graph'
import { LtResizeBox } from '@lit-element/components/resize-box'
import { LtMarquee } from '@lit-element/components/marquee'
import { LtVideo } from '@lit-element/components/video'
import type { Plugin } from 'vue'

export default [
  LtAffix,
  LtAlert,
  LtAutocomplete,
  LtAutoResizer,
  LtAvatar,
  LtBacktop,
  LtBadge,
  LtBreadcrumb,
  LtBreadcrumbItem,
  LtButton,
  LtButtonGroup,
  LtCalendar,
  LtCard,
  LtCarousel,
  LtCarouselItem,
  LtCascader,
  LtCascaderPanel,
  LtCheckTag,
  LtCheckbox,
  LtCheckboxButton,
  LtCheckboxGroup,
  LtCol,
  LtCollapse,
  LtCollapseItem,
  LtCollapseTransition,
  LtColorPicker,
  LtConfigProvider,
  LtContainer,
  LtAside,
  LtFooter,
  LtHeader,
  LtMain,
  LtDatePicker,
  LtDescriptions,
  LtDescriptionsItem,
  LtDialog,
  LtDivider,
  LtDrawer,
  LtDropdown,
  LtDropdownItem,
  LtDropdownMenu,
  LtEmpty,
  LtForm,
  LtFormItem,
  LtIcon,
  LtImage,
  LtImageViewer,
  LtInput,
  LtInputNumber,
  LtLink,
  LtHighlight,
  LtMenu,
  LtMenuItem,
  LtMenuItemGroup,
  LtSubMenu,
  LtPageHeader,
  LtPagination,
  LtPopconfirm,
  LtPopover,
  LtPopper,
  LtProgress,
  LtRadio,
  LtRadioButton,
  LtRadioGroup,
  LtRate,
  LtResult,
  LtRow,
  LtScrollbar,
  LtSelect,
  LtOption,
  LtOptionGroup,
  LtSelectV2,
  LtSkeleton,
  LtSkeletonItem,
  LtSlider,
  LtSpace,
  LtStatistic,
  ltCountdown,
  LtSteps,
  LtStep,
  LtSwitch,
  LtTable,
  LtTableColumn,
  LtTableV2,
  LtTabs,
  LtTabPane,
  LtTag,
  LtText,
  LtTimePicker,
  LtTimeSelect,
  LtTimeline,
  LtTimelineItem,
  LtTooltip,
  LtPopoverTip,
  LtTransfer,
  LtTree,
  LtTreeSelect,
  LtTreeV2,
  LtUpload,
  LtWatermark,
  LtTour,
  LtTourStep,
  LtAnchor,
  LtAnchorLink,
  LtSegmented,
  LtMention,
  LtQrcode,
  LtWheel,
  LtEllipsis,
  LtTimeAgo,
  LtSplit,
  LtViewer,
  LtCaptcha,
  LtCaptchaSlider,
  LtFullScreen,
  LtMasker,
  LtRenderer,
  LtEditorMd,
  LtRenderMd,
  LtOverflow,
  LtCodeEditor,
  LtComment,
  LtVerificationCode,
  LtResizeObserver,
  LtGitGraph,
  LtResizeBox,
  LtMarquee,
  LtVideo,
] as Plugin[]
